<div class="modal-header">
    <h4 class="modal-title font-weight-bold">{{ "SETTINGS.FOLDERS.MODAL.TITLE" | translate }} {{folder.title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">

    <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>

    <form class="form-inline" *ngIf="folderForm" [formGroup]="folderForm" novalidate (ngSubmit)="updateFolder(folderForm.value)">
        <div class="form-group">
            <label for="name">{{ "SETTINGS.FOLDERS.MODAL.NEW-FOLDER-NAME" | translate }}</label>
            <input type="text" class="form-control mx-2" placeholder="{{ 'SETTINGS.FOLDERS.MODAL.NEW-FOLDER-NAME-FORM' | translate }}" formControlName="name" id="name">
            <button type="submit" class="btn btn-primary" [disabled]="!folderForm.valid">{{ "BUTTONS.VALIDATE" | translate }}</button>
        </div>
    </form>
    <div class="mt-2">
        <mat-error *ngIf="hasError('name', 'required')">{{ "ERRORS.FOLDER-NAME-REQUIRED" | translate }}</mat-error>
    </div>
</div>

